import { LoadingIndicatorWrapper } from '../styles'
import { useTheme } from 'styled-components'
import SyncLoader from 'react-spinners/SyncLoader'

export const LoadingIndicator = () => {
  const theme = useTheme()

  return (
    <LoadingIndicatorWrapper>
      <SyncLoader color={theme.background.tertiary} loading />
    </LoadingIndicatorWrapper>
  )
}
